module.exports = __webpack_public_path__ + "img/is_receive_box.3aec97c2.png";